import type { AdapterProject } from "@/features/adapters/model";

const withTrailingSlash = (value: string | undefined): string | undefined => {
  const normalized = value?.trim();
  if (!normalized) return undefined;
  return normalized.endsWith("/") ? normalized : `${normalized}/`;
};

export interface AdapterFileProcessingDetails {
  enabled: boolean;
  authentication: string;
  host?: string;
  username?: string;
  stagingPath?: string;
  processedPath?: string;
  errorPath?: string;
  ready: boolean;
}

export const getAdapterFileProcessingDetails = (
  project: AdapterProject | undefined,
): AdapterFileProcessingDetails => {
  const fileProcessing = project?.fileProcessing;
  const pathPrefix = withTrailingSlash(
    fileProcessing?.pathPrefix ?? fileProcessing?.basePath,
  );
  const stagingPath = withTrailingSlash(
    fileProcessing?.stagingPath ?? (pathPrefix ? `${pathPrefix}staging` : undefined),
  );
  const processedPath = withTrailingSlash(
    fileProcessing?.processedPath ?? (pathPrefix ? `${pathPrefix}processed` : undefined),
  );
  const errorPath = withTrailingSlash(
    fileProcessing?.errorPath ?? (pathPrefix ? `${pathPrefix}error` : undefined),
  );
  const usesKeys = fileProcessing?.useSshKeys !== false;
  const usesPassword = Boolean(fileProcessing?.usePassword);
  const authentication = usesKeys && usesPassword
    ? "SSH key and password"
    : usesKeys
      ? "SSH key"
      : usesPassword
        ? "Password"
        : "Not configured";
  const enabled = Boolean(fileProcessing?.enabled);
  const ready = Boolean(
    enabled &&
      fileProcessing?.sftpHost &&
      fileProcessing?.username &&
      stagingPath &&
      processedPath &&
      errorPath &&
      (usesKeys || usesPassword),
  );

  return {
    enabled,
    authentication,
    host: fileProcessing?.sftpHost,
    username: fileProcessing?.username,
    stagingPath,
    processedPath,
    errorPath,
    ready,
  };
};
